import { render, staticRenderFns } from "./ButtonSupportTicket.vue?vue&type=template&id=c6252664&"
import script from "./ButtonSupportTicket.vue?vue&type=script&lang=js&"
export * from "./ButtonSupportTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports